import React from "react";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import UplusTab, {
  uplusTabState,
} from "../../components/pages/Party/UplusInfo/UplusTab";
import { useRecoilValue } from "recoil";
import UplusMatchingInfo from "./UplusMatchingInfo";
import UplusDataUploadInfo from "../../components/pages/Party/UplusInfo/UplusDataUploadInfo";

export default function UplusInfo() {
  const uplusTab = useRecoilValue(uplusTabState);

  return (
    <>
      <PageTitle title="유플러스 결합 관리" />

      <UplusTab />

      {uplusTab === 0 ? <UplusMatchingInfo /> : <UplusDataUploadInfo />}
    </>
  );
}
